
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "ChangeLang",
  computed: mapGetters("app", ["getCategories"])
})
export default class Cookie extends Vue {
  getCategories: any[];
  async handleLangSelect(lang: string) {
    await this.$store.dispatch("app/setCurrentLang", lang.toLocaleLowerCase());
    if (this.$router.currentRoute.name === "shops") {
      this.$store.dispatch("shops/getAllShops");
    }

    if (this.$router.currentRoute.name === "products") {
      this.$store.dispatch("products/setLangChangeState", [true]);
      await this.$store.dispatch("products/getCategories");

      const categoryID = this.getCategories[0]["category_id"];
      this.$store.dispatch("products/fetchFilterParams", [categoryID]);
      this.$store.dispatch("products/fetchProducts", {category: categoryID, count: 20, direction: null});
      this.$router.push({ path: `/products?category=${categoryID}` });

      this.$store.dispatch("products/setLangChangeState", [false]);
    }
  }
}
